<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-layout align-center justify-center>
          <v-card style="width: 100%; max-width: 800px">
            <v-card-title primary-title>
                <div>
                  <div class="headline pl-2 pa-1">{{ $t("communication.createSpecialEvent.heading") }}</div>
                </div>
              </v-card-title>
              <v-form ref="form" v-model="form" class="pa-4 pt-6">
                <v-text-field outline v-model="model.name" :rules="[rules.required]" :label="$t('common.name')"
                  type="text"></v-text-field>

                <div class="datetime-field">
                  <label class="datetime-label">{{ $t("common.from") }}</label>
                  <date-picker
                    class="gray-placeholder time-picker"
                    type="datetime"
                    valueType="format"
                    format="DD-MM-YYYY HH:mm"
                    :placeholder="$t('communication.createSpecialEvent.enterDate')"
                    :append-to-body="false"
                    v-model="from"
                    :confirm="true"
                    prefix-class="xmx"
                    :minute-step="5"
                  ></date-picker>
                </div>

                <div class="datetime-field">
                  <label class="datetime-label">{{ $t("common.to") }}</label>
                  <date-picker
                    class="gray-placeholder time-picker"
                    type="datetime"
                    valueType="format"
                    format="DD-MM-YYYY HH:mm"
                    :placeholder="$t('communication.createSpecialEvent.enterDate')"
                    :append-to-body="false"
                    v-model="to"
                    :confirm="true"
                    prefix-class="xmx"
                    :minute-step="5"
                  ></date-picker>
                </div>

                <v-btn :loading="loading" block @click="createSpecialEvent" color="secondary" dark>{{ $t("common.create") }}</v-btn>
              </v-form>
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import DatePicker from "vue2-datepicker";

export default {
  title() {
    return this.$t("communication.createSpecialEvent.title");
  },
  components: {
    DatePicker,
  },
  data: () => ({
    from: "",
    to: "",
    model: {
      name: "",
    },

    loading: false,
    form: false,
  }),

  computed: {
    rules() {
      return {
        required: (v) => !!v || this.$t("communication.createSpecialEvent.rules.required"),
      };
    },
  },

  methods: {
    createSpecialEvent() {
      if (!this.$refs.form.validate()) return;

      if (!this.from || !this.to) {
        window.getApp.$emit("SHOW_TOAST", this.$t("communication.createSpecialEvent.selectFromTo"), "red");
        return;
      }

      const fromDate = moment(this.from, "DD-MM-YYYY HH:mm");
      const toDate = moment(this.to, "DD-MM-YYYY HH:mm");
      if (toDate.isSameOrBefore(fromDate)) {
        window.getApp.$emit("SHOW_TOAST", this.$t("communication.createSpecialEvent.toAfterFrom"), "red");
        return;
      }

      this.loading = true;
      this.axios
        .post("special-event", {
          name: this.model.name,
          from: fromDate.format("YYYY-MM-DD HH:mm"),
          to: toDate.format("YYYY-MM-DD HH:mm"),
        })
        .then(() => {
          window.getApp.$emit("SHOW_TOAST", this.$t("communication.createSpecialEvent.createdSuccessfully"), "green");
          this.$router.push("/special_events");
        })
        .catch((err) => {
          let response = err.response;
          if (response) {
            window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
          } else {
            window.getApp.$emit("SHOW_TOAST", this.$t("communication.createSpecialEvent.checkInfo"), "red");
          }
        })
        .then(() => (this.loading = false));
    },
  },
};
</script>

<style lang="scss" scoped>
.datetime-field {
  margin-bottom: 22px;
}

.datetime-label {
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
}

.datetime-field ::v-deep .xmx-datepicker {
  width: 100%;
}

.datetime-field ::v-deep .xmx-input {
  height: 56px;
  padding: 0 40px 0 18px !important;
  border: 2px solid rgba(0, 0, 0, 0.54) !important;
  border-radius: 4px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.87);
  box-shadow: none;
}

.datetime-field ::v-deep .xmx-input:hover,
.datetime-field ::v-deep .xmx-input:focus {
  border-color: rgba(0, 0, 0, 0.87) !important;
}

::v-deep .v-card {
  overflow: visible !important;
}
</style>
